import { MediaQueryBreakPoint } from '@execonline-inc/execonline-ui';
import { Experience } from '../../../../Experience/Types';

function getSchoolPartnerLogoHeight(breakPoint: MediaQueryBreakPoint) {
  switch (breakPoint) {
    case 'xl':
    case 'lg':
    case 'md':
      return 54;
    case 'sm':
    case 'xs':
      return 40;
  }
}

export const schoolPartnerLogoProps = (
  experience: Experience,
  breakPoint: MediaQueryBreakPoint,
): { height: number } => {
  switch (experience.offeringType) {
    case 'coaching':
    case 'program-sequence':
      return { height: 22 };
    case 'aep':
    case 'epc':
    case 'msuite':
    case 'group-coaching':
      return { height: getSchoolPartnerLogoHeight(breakPoint) };
  }
};
